export default __webpack_public_path__ + "static/apparel-5119a2586384295aea2b3f1e2b138e14.png";